import React from 'react';
import $ from 'jquery';

import AuthorizationCheck from '../auth/authorizationCheck';
import CountryService from '../services/country';
import Customer from '../services/customer';
import OrderService from '../services/order';
import CreateCustomerOrderModal from './CreateCustomerOrderModal';

class Customers extends React.Component {

    constructor() {
        super();

        this.customerService = new Customer();
        this.countryService = new CountryService();
        this.orderService = new OrderService();

        this.state = {
            currentUserRole: '',
            customers: [],
            countries: [],

            showCreateOrderForm: false,
            selectedOrderCustomer: null
        };
    }

    componentDidMount() {
        this.countryList();
        this.customerList();
    }

    setRole = (role) => {
        this.setState({ currentUserRole: role });
    }

    countryList = async () => {
        try {
            const res = await this.countryService.fetchCountries();
            this.setState({ countries: await res.json() });
        } catch (error) {
            console.log(error);
        }
    }

    customerList = async () => {
        try {
            let searchTerm = $('#searchTerm').val();
            let countryId = $('#searchCountryId').val();

            const res = await this.customerService.customerList(
                countryId,
                searchTerm
            );

            if (res.ok) {
                this.setState({
                    customers: await res.json()
                });
            }
        } catch (error) {
            console.log(error);
        }
    }

    findClients = () => {
        clearTimeout(this.searchTimeout);

        this.searchTimeout = setTimeout(() => {
            this.customerList();
        }, 500);
    }

    showOrderForm = (customer) => {
        this.setState({
            selectedOrderCustomer: customer,
            showCreateOrderForm: true
        });
    }

    hideOrderForm = () => {
        this.setState({
            selectedOrderCustomer: null,
            showCreateOrderForm: false
        });
    }

    createOrder = async (orderDto) => {
        try {
            const res = await this.orderService.createCustomerOrder(orderDto);

            if (res.ok) {
                $('#create-order-message').html(
                    '<div class="alert alert-success">Commande créée</div>'
                );

                setTimeout(() => {
                    this.hideOrderForm();
                }, 700);

                return;
            }

            $('#create-order-message').html(
                '<div class="alert alert-danger">Operation non Aboutie</div>'
            );

        } catch (error) {
            console.log(error);

            $('#create-order-message').html(
                '<div class="alert alert-danger">Operation non Aboutie</div>'
            );
        }
    }

    render() {
        const countries = this.state.countries;
        const customers = this.state.customers;

        let searchCountries = '';

        if (
            this.state.currentUserRole === 'MANAGER' ||
            this.state.currentUserRole === 'SUPER-ADMIN'
        ) {
            searchCountries = (
                <div className="form-group">
                    <label className="label">Choisi le Pays</label>

                    <select
                        className="form-control"
                        id="searchCountryId"
                        onChange={this.customerList}
                    >
                        <option key={0}></option>

                        {countries.length > 0 && countries.map(country =>
                            <option
                                key={country.countryId}
                                value={country.countryId}
                            >
                                {country.name}
                            </option>
                        )}
                    </select>
                </div>
            );
        }

        return (
            <div className='customer-wrapper'>

                <AuthorizationCheck
                    accessLevel='ADMIN'
                    userRole={this.setRole}
                />

                <CreateCustomerOrderModal
                    show={this.state.showCreateOrderForm}
                    onClose={this.hideOrderForm}
                    customer={this.state.selectedOrderCustomer}
                    onCreate={this.createOrder}
                />

                <div className="container form-wrapper">
                    <h2>Clients</h2>
                </div>

                <div className='container mt-2'>
                    <div className='form-wrapper'>
                        {searchCountries}

                        <div className="form-group">
                            <input
                                className="form-control"
                                onKeyUp={this.findClients}
                                id="searchTerm"
                                placeholder="Nom ou address"
                            />
                        </div>
                    </div>
                </div>

                <div className='container'>
                    {customers.length > 0 && customers.map(customer =>
                        <div
                            className="card card-default mt-2"
                            key={customer.customerId}
                        >
                            <div className="card-body">
                                <div className="row">
                                    <div className="col">
                                        {customer.name}
                                    </div>

                                    <div className="col">
                                        {customer.address}
                                    </div>

                                    <div className="col">
                                        {customer.country && customer.country.name}
                                    </div>

                                    <div className="col">
                                        <a
                                            href={
                                                '/customer/order/list?customerId=' +
                                                customer.customerId
                                            }
                                        >
                                            <button className="btn btn-primary">
                                                Commandes
                                            </button>
                                        </a>
                                    </div>

                                    <div className="col">
                                        <button
                                            className="btn btn-success"
                                            onClick={() => this.showOrderForm(customer)}
                                        >
                                            Nouvelle Commande
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}

                    {customers.length === 0 &&
                        <div className="alert alert-info mt-3">
                            Aucun client trouvé
                        </div>
                    }
                </div>

            </div>
        );
    }
}

export default Customers;